export default __webpack_public_path__ + "static/media/evolve-3-1.3a524d64.png";